<template>
  <div class="news-list">
    <div class="news-list-content" v-for="(item, index) in data" :key="index">
      <HomeNewsListItem :data="item"></HomeNewsListItem>
    </div>
  </div>
</template>

<script>
import HomeNewsListItem from '@/components/news-monitor/HomeNewsListItem';

export default {
  props: {
    data: {
      type: Array
    }
  },
  components: {
    HomeNewsListItem
  }
};
</script>

<style lang="scss" scoped>
  .news-list {
    background-color: #3e3c42;
  }

</style>



